// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoDataproc } from '../../../assets/images/Logos/logo-dataproc.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoDataprocIcon = /* @__PURE__ */ withLogoClass(LogoDataproc);
